import {
  LOAD_SUCCESS_LOCATAIRES,
  LOAD_FAIL_LOCATAIRES,
  SAVE_SUCCESS_LOCATAIRES,
  SAVE_FAIL_LOCATAIRES,
  UPDATE_SUCCESS_LOCATAIRES,
  UPDATE_FAIL_LOCATAIRES,
  DELETE_SUCCESS_LOCATAIRES,
  DELETE_FAIL_LOCATAIRES,
} from "../actions/locataireAction";

import { SAVE_SUCCESS_LOCATAIRES_AFFECTATIONS } from "../actions/locataireAffectationAction";

const initialState = {
  loaded: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SUCCESS_LOCATAIRES:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.payload,
        error: null,
      };
    case LOAD_FAIL_LOCATAIRES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    case SAVE_SUCCESS_LOCATAIRES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: [...(state.data || []), action.payload],
        error: null,
      };
    case SAVE_FAIL_LOCATAIRES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case UPDATE_SUCCESS_LOCATAIRES:
      const updatedListe = [];
      state.data.forEach((item) => {
        if (item.locataire_id === action.payload.locataire_id) {
          item = action.payload;
        }
        updatedListe.push(item);
      });

      return {
        ...state,
        loading: false,
        loaded: true,
        data: updatedListe,
        error: null,
      };
    case UPDATE_FAIL_LOCATAIRES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case DELETE_SUCCESS_LOCATAIRES:
      const filtered = state.data.filter((item) => {
        return item.groupe_id !== action.id;
      });
      return {
        ...state,
        loading: false,
        loaded: true,
        data: filtered,
        error: null,
      };
    case DELETE_FAIL_LOCATAIRES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case SAVE_SUCCESS_LOCATAIRES_AFFECTATIONS:
      const addAffectation = [];

      state.data.forEach((locataire) => {
        if (locataire.locataire_id === action.id)
          locataire.locataire_affectations.push(action.payload);

        addAffectation.push(locataire);
      });
      return {
        ...state,
        loading: false,
        loaded: true,
        data: addAffectation,
        error: null,
      };
    default:
      return state;
  }
}
